<template>
  <div
    :class="`mysql-code-${theme}`"
    id="code-component"
    @keydown="handleKeyDown"
  >
    <Header
      :themeColor="themeColor"
      :loading="runLoading"
      :title="title"
      runText="运行"
      @run="run"
      :disabled="disabledRun"
      :theme="theme"
      :resultText="getResultText"
      :language="language"
      :showDownload="showDownload"
      :showCheckFullScreen="showCheckFullScreen"
      @download="download"
    />
    <Code
      :refId="generateId"
      ref="code"
      class="code"
      :language="modeLanguage"
      :paramsLanguage="paramsLanguage"
      :inputCode="inputCode"
      v-model="input"
      :output="outputResult || output"
      :disabled="disabledInput"
      :isVertical="isVertical"
      :theme="theme"
      :readOnlyCoreCode="readOnlyCoreCode"
    />
  </div>
</template>
<script type="text/babel">
import Code from "../code/Code.vue";
import file from "../../utils/file";
import request from "../../requests";
import Header from "../header/Header.vue";

export default {
  name: "JOnlineCode",
  components: {
    Code,
    Header
  },
  model: {
    prop: "input"
  },
  props: {
    // 输入
    inputCode: {
      type: String,
      default: ""
    },
    // 主题色（头部）
    themeColor: {
      type: String,
      default: "#0fc700"
    },
    // 是否可输入
    disabledInput: {
      type: Boolean,
      default: false
    },
    disabledRun: {
      type: Boolean,
      default: false
    },
    // 文件集id
    projectId: {
      type: String,
      default: null
    },
    // 用户id
    userId: {
      type: String,
      default: null
    },
    // 是否竖屏
    isVertical: {
      type: Boolean,
      default: true
    },
    // 是否亮色模式
    theme: {
      type: String,
      default: "dark"
    },
    title: {
      type: String,
      default: "练习"
    },
    // 环境
    env: {
      type: String,
      default: "vip"
    },
    // 语言
    language: {
      type: String,
      required: true
    },
    // 预设答案，用于运行提示，可为空
    answer: {
      type: String,
      default: ""
    },
    // 是否显示校验信息
    showResultText: {
      type: Boolean,
      default: true
    },
    // 是否显示下载按钮
    showDownload: {
      type: Boolean,
      default: true
    },
    // 内网URL
    urlReplace: {
      type: String
    },
    // 为了支持考试场景暂时先加2个props
    // 运行结果
    outputResult: {
      type: Object,
      default: () => {}
    },
    // 结果文案
    editableResult: {
      type: String,
      default: ""
    },
    showCheckFullScreen: {
      type: Boolean,
      default: true
    },
    // 是否开启只读关键代码功能 默认不开启
    readOnlyCoreCode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    input(val) {
      this.$emit("input", val);
    }
  },
  data() {
    return {
      // language: 'mysql', //for run
      output: {},
      runLoading: false,
      input: "",
      // 校验结果
      resultText: "",
      // 维护一个语言字段，在发接口的时候统一使用该字段
      paramsLanguage: "",
      generateId: ""
    };
  },
  computed: {
    modeLanguage() {
      const formatLanguage = this.language.toLowerCase();
      if (formatLanguage.includes("sql")) {
        this.paramsLanguage = "mysql";
        return "sql";
      } else if (
        formatLanguage.includes("node") ||
        formatLanguage.includes("javascript")
      ) {
        // 接口传node codemirror传javascript
        this.paramsLanguage = "node";
        return "javascript";
      } else if (
        formatLanguage.includes("java") &&
        !formatLanguage.includes("javascript")
      ) {
        this.paramsLanguage = "java";
        return "java";
      } else if (formatLanguage.includes("c++")) {
        this.paramsLanguage = "cpp";
        return "cpp";
      } else if (formatLanguage.includes("python")) {
        this.paramsLanguage = "python";
        return "python";
      } else if (formatLanguage.includes("oracle")) {
        this.paramsLanguage = "oracle";
        return "sql";
      } else if (formatLanguage.includes("shell")) {
        this.paramsLanguage = "shell";
        return "shell";
      } else {
        this.paramsLanguage = this.language;
        return this.language;
      }
    },
    getResultText() {
      if (this.showResultText) {
        return this.editableResult || this.resultText;
      }
      return "";
    }
  },
  created() {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'; // 字符集合
    const length = 10; // ID长度
    let randomId = '';
    for (var i = 0; i < length; i++) {
        var index = Math.floor(Math.random() * chars.length);
        randomId += chars[index];
    }
    this.generateId = randomId;
  },
  methods: {
    handleKeyDown() {
      event.stopPropagation();
    },
    run() {
      this.$emit("startRun");
      this.runLoading = true;
      this.output = null;
      let inputCode = this.$refs.code.code;
      if (!inputCode) {
        this.$message.error("请填写内容！");
        this.runLoading = false;
        return;
      }
      const data = window.btoa(encodeURIComponent(inputCode));
      request
        .startTest(
          this.paramsLanguage,
          this.projectId,
          this.env,
          { code: data },
          this.urlReplace
        )
        .then(res => {
          const dataTemp = res.data;
          this.output = dataTemp;
          if (this.output.stream_type === 'STDOUT') {
            this.output.code = 200;
            this.output.data = dataTemp.payload;
            if (this.answer) {
              if (this.output.payload.trim() === this.answer) {
                this.resultText = "答案正确";
              } else {
                this.resultText = "答案错误";
              }
            } else {
              this.resultText = "运行成功";
            }
            if (this.modeLanguage === 'sql') {
              this.output.result_arr = dataTemp.sql_info.map((info,index) => {
                return {
                  code: 200,
                  data: info.sql_res_row,
                  tab: `tab ${index+1}`
                }
              })
            }
          } else {
            this.output.msg = dataTemp.payload;
            if (this.modeLanguage === 'sql') {
              this.output.msg = dataTemp.sql_info[0] && dataTemp.sql_info[0].sql_res_row[0].error
            }
            this.resultText = "运行出错";
          }
          this.$emit("success", this.output);
        })
        .catch(() => {
          this.resultText = "编程服务有点小故障，请联系极客管理员";
          // this.output = {
          //   code: 200,
          //   result_arr: [
          //     {
          //       tab: "tab 1",
          //       code: 200,
          //       data: {
          //         metaData: [
          //           {
          //             name: "item_id"
          //           },
          //           {
          //             name: "style_id"
          //           },
          //           {
          //             name: "tag_price"
          //           },
          //           {
          //             name: "inventory"
          //           }
          //         ],
          //         rows: [["123", "2", 3, 4]]
          //       }
          //     }
          //   ]
          // };
        })
        .finally(() => {
          this.runLoading = false;
        });
    },
    download() {
      if (this.inputCode) {
        let fileName = "test";
        file.saveFile(fileName, this.paramsLanguage, this.inputCode);
      } else {
        this.$message.error("请填写内容再保存");
      }
    },
    resetCode() {
      this.$refs.code.handleResetCode()
    }
  }
};
</script>
<style scoped>
.mysql-code-dark {
  height: 100%;
  width: 100%;
  background-color: rgb(0, 0, 0,0.85);
  display: flex;
  flex-direction: column;
}
.mysql-code-light {
  height: 100%;
  width: 100%;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
}
.mysql-code > .code {
  padding: 0 10px 10px;
  flex: 1;
}
</style>
